export default __webpack_public_path__ + "static/media/panda comerce.ea36d672.png";